import React from 'react';
import {Button, Tooltip} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ChevronLeftIcon } from '../../assets/icons/chevron-left.svg';
import { useTranslation } from 'react-i18next';

interface BackButtonProps {
  onClick?: () => void;
  text?: string;
  to?: string | number;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  onClick, 
  text, 
  to = -1 
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (typeof to === 'number') {
      navigate(to);
    } else {
      navigate(to);
    }
  };

  return (
      <Tooltip title={`${t('sidebar.goBack')}`}>
        <Button
          startIcon={<ChevronLeftIcon />}
          onClick={handleClick}
          variant="text"
          sx={{
            padding: '8px',
            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
          }}
        >
          {text || t('common.back')}
        </Button>
      </Tooltip>
  );
};

export default BackButton;
